export enum FileTypes {
    PDF = 'application/pdf',
    DOC = 'application/vnd.ms-word',
    DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    XLS = 'application/vnd.ms-excel',
    XLXS = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    PPT = 'application/vnd.ms-powerpoint',
    PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    JPG = 'image/jpeg',
    PNG = 'image/png',
    GIF = 'image/gif'
}

export const KeyCode = {
    TAB: 9,
    UP_ARROW: 38,
    DOWN_ARROW: 40,
    ENTER: 13
};

export const RowHeight = 42;
export const MaxAllowedAttemptsStepOne: number = 5;
export const MaxAllowedAttemptsStepTwo: number = 2;

export enum RegistrationStep {
    ProviderInformation = 'ProviderInformation',
    ExperianQuestions = 'ExperianQuestions',
    ClinicInformation = 'ClinicInformation',
    ContractAgreement = 'ContractAgreement',
    PaymentInformation = 'PaymentInformation',
    Attachments = 'Attachments',
    Summary = 'Summary',

    CompleteWithFailAllowedRetry = 'CompleteWithFailAllowedRetry',
    CompleteWithPermanentFail = 'CompleteWithPermanentFail',
    FailUserExist = 'FailUserExist'
}

export enum WorkflowContext {
    WorkFlowData = '_WorkFlowData_',
    WorkingRegistrationId = '_WorkingRegistrationId_',
    EXPERIAN_SESSION_ID = 'ExperianSessionId',
    EXPERIAN_QUESTIONS = 'ExperianQuestions',
    ATTEMPT_COUNTER_STEP_ONE = 'AttemptCounterStepOne',
    ATTEMPT_COUNTER_STEP_TWO = 'AttemptCounterStepTwo',
    USER_INFO = 'UserInfo',

    PROVIDER_INFO_PAYMENT = 'ProviderInfoPayment',
    PROVIDER_INFORMATION_PAYMENT = 'ProviderInformationPayment'
}

export enum ErrorMessageType {
    // Step 1
    EXIST_USER_FACILITY='EXIST_USER_FACILITY',
    TERMINATED_USER='TERMINATED_USER',
    GENERAL_ERROR='GENERAL_ERROR',

    // Step 4
    ERROR_FROM_INTERNAL_SYSTEM = 'ERROR_FROM_INTERNAL_SYSTEM',
    ERROR_FROM_STRIPE = 'ERROR_FROM_STRIPE'
}

export enum MaskPattern {
    DATE_PICKER = '99/99/9999',
    PHONE_NUMBER = '(999) 999-9999',
    NPI = '9999999999'
}


// WEBPACK FOOTER //
// ./src/utils/constValues.ts